import { IProjectUsage } from 'interfaces';

import { IGetOverallProjectUsageTableDataParams, IGroupedProjectUsage, IOverallProjectUsageTableData } from './OverallTranslateTableView.interfaces';


const groupAndSumProjectUsage = (projectUsages: IProjectUsage[] ): IGroupedProjectUsage[] => {
  // Helper to get date in YYYY-MM-DD format
  const getDate = (d: string) => d.split('T')[0];

  const map: {
    [key: string]: IGroupedProjectUsage;
  } = {};

  projectUsages.forEach(item => {
    const date = getDate(item.date);
    const key = `${date}|${item.action}|${item.apiKeyTitle}`;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!map[key]) {
      map[key] = {
        date,
        action: item.action,
        apiKeyTitle: item.apiKeyTitle,
        characters: 0,
      };
    }
    map[key].characters += item.characters;
  });

  // Convert to array and sort by date desc
  return Object.values(map).sort((a, b) => b.date.localeCompare(a.date));
}

const getOverallProjectUsageTableData = ({ projectUsages = [] }: IGetOverallProjectUsageTableDataParams): IOverallProjectUsageTableData[] => {
  return projectUsages.map(
    ({
      action,
      apiKeyTitle,
      characters,
      date,
    }): IOverallProjectUsageTableData => ({
      id: `${apiKeyTitle}-${date}-${action}`,
      action,
      apiKeyTitle,
      characters,
      date,
    }),
  );
};

export { getOverallProjectUsageTableData, groupAndSumProjectUsage };
